import axios from 'axios';
import { notification } from 'antd';
import history from '../history';
import { AUTH_TOKEN, API_URL } from '../configs/AppConfig';
import { logout } from '../utils/logout';

const unauthorizedCode = [401];

const service = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = '/auth/login';
const TOKEN_PAYLOAD_KEY = 'token';
const PUBLIC_REQUEST_KEY = 'public-request';

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }

    if (
      !jwtToken &&
      !config.headers[PUBLIC_REQUEST_KEY] &&
      !isLoginRelatedApi(config)
    ) {
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }
    if (config.url.includes('/calculate-impact')) {
      config.timeout = 300000;
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: 'Error',
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      notification.error({
        message: 'Session Expired',
        description: 'Please login again',
      });

      logout();
      return Promise.reject(error);
    }

    if (status === 404) {
      notification.error({ message: 'Not Found' });
    }

    if (status === 500) {
      notification.error({ message: 'Internal Server Error' });
      logout();
    }

    if (status === 508) {
      notification.error({ message: 'Time Out' });
    }

    return Promise.reject(error);
  }
);

const isLoginRelatedApi = (config) => {
  const { url } = config;
  return url.includes('/auth');
};
export default service;
